"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Zoom = _interopRequireDefault(require("./Zoom"));

var _PageIncrement = _interopRequireDefault(require("./PageIncrement"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    root: {
      display: 'grid',
      gridTemplateRows: '1fr',
      gridTemplateColumns: 'repeat(3, 1fr)',
      backgroundColor: theme.palette.bottomDialogBackground,
      paddingRight: 12
    },
    actionBarLeftContainer: {
      display: 'grid',
      alignContent: 'center',
      gridAutoFlow: 'column',
      marginLeft: '15%',
      overflow: 'hidden'
    },
    documentTitle: {
      lineHeight: '3',
      color: '#7b7b7b',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    tooltip: {
      fontSize: '0.9rem !important'
    }
  };
};

var ActionBar = function ActionBar(props) {
  var actionButtons = props.actionButtons,
      classes = props.classes,
      setPage = props.setPage,
      setZoom = props.setZoom,
      setCurrentDocument = props.setCurrentDocument,
      resetZoom = props.resetZoom,
      page = props.page,
      pageCount = props.pageCount,
      prevDocId = props.prevDocId,
      nextDocId = props.nextDocId,
      className = props.className,
      withSidebar = props.withSidebar,
      documentTitle = props.documentTitle;
  var alignZoomEnd = withSidebar;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.actionBarLeftContainer
  }, documentTitle && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: documentTitle,
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes.documentTitle
  }, documentTitle)), /*#__PURE__*/_react.default.createElement(_Zoom.default, {
    setZoom: setZoom,
    resetZoom: resetZoom,
    alignZoomEnd: alignZoomEnd,
    withSidebar: withSidebar
  })), /*#__PURE__*/_react.default.createElement(_PageIncrement.default, {
    setPage: setPage,
    setCurrentDocument: setCurrentDocument,
    page: page,
    pageCount: pageCount,
    prevDocId: prevDocId,
    nextDocId: nextDocId,
    withSidebar: withSidebar
  }), actionButtons);
};

var _default = (0, _styles.withStyles)(styles)(ActionBar);

exports.default = _default;